"use client";

import { SearchInput } from "@punchup/ui-common/components/common";

interface VenueShowsSearchProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
}

export default function VenueShowsSearch({
  searchQuery,
  setSearchQuery,
}: VenueShowsSearchProps) {
  return (
    <div className="w-full md:w-[550px]">
      <SearchInput
        placeholder="Search shows or comedians..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        onClear={() => setSearchQuery("")}
      />
    </div>
  );
}
